import { Trans } from '@lingui/react'
import { TelephoneTextInput } from '../../TextInput/TelephoneTextInput'

export function TelephoneFields(props) {
  const { formState, required, register } = props
  return (
    <div>
      <TelephoneTextInput
        type='text'
        error={!!formState.errors.telephone}
        required={required}
        topLabel={<Trans id='Telephone' />}
        register={register}
        helperText={formState.errors.telephone?.message}
        disabled={formState.isSubmitting}
        className='w-full'
      />
    </div>
  )
}
